// src/Contact.js
import React, { useState } from 'react';
import './Contact.css';

export default function Contact() {
  const [status, setStatus] = useState(null);   // null | 'SUCCESS' | 'ERROR'
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(e.target);

    const res = await fetch('https://formspree.io/f/mgvyppde', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });

    if (res.ok) {
      e.target.reset();
      setStatus('SUCCESS');
    } else {
      setStatus('ERROR');
    }
    setLoading(false);
  }

  return (
    <>
      <section className="contact-wrapper">
        <h1>Have questions?</h1>
        <p>
          Ask us about anything and we’ll get back to you within 24 hours. <br />
          Send us a message or email us at mikayla@kayavisuals.com.
        </p>

        {status === 'SUCCESS' && (
          <p className="contact-success">Thanks — we’ll be in touch soon!</p>
        )}
        {status === 'ERROR' && (
          <p className="contact-error">Sorry, something went wrong. Try again?</p>
        )}

        <form onSubmit={handleSubmit} className="contact-form">
          <label>
            Name
            <input type="text" name="name" required />
          </label>

          <label>
            Email
            <input type="email" name="email" required />
          </label>

          <label>
            Message
            <textarea name="message" rows="5" required />
          </label>

          <button type="submit" disabled={loading}>
            {loading ? 'Sending…' : 'Send message'}
          </button>
        </form>

        {/* Schedule Call Callout */}
        <div className="schedule-call">
          <p>Have questions or want to learn more? Our team is happy to chat!</p>
          <a
            href="https://calendly.com/kayavisuals03/30min"
            target="_blank"
            rel="noopener noreferrer"
            className="schedule-btn"
          >
            Talk to a team member
          </a>
        </div>
      </section>

      {/* FOOTER */}
  <footer className="site-footer">
        <div className="footer-inner">
          <nav className="footer-nav">
            <a href="/about">About</a>
            <a href="/contact">Contact</a>
            <a href="/blog">Blog</a>
          </nav>
          <p className="footer-legal">
            © {new Date().getFullYear()} Kaya Visuals · Austin, TX
          </p>
        </div>
      </footer>
    </>
  );
}
